<template>
  <div class="documents-content">
    <header class="documents-header">
      <span class="section-kicker">Documentos oficiales</span>
      <h2>Información y formularios</h2>
      <p>
        Consulta o descarga la normativa y los formularios oficiales del Bono
        Juancito Pinto.
      </p>
    </header>

    <div class="documents-grid">
      <download-card
        title="Decreto Supremo"
        description="Decreto Supremo N.º 5712 · Gestión 2026"
        file-url="files/DECRETO SUPREMO 5712 2026 BJP.pdf"
        file-type="pdf"
      />

      <download-card
        title="Reglamento de Entrega"
        description="Reglamento oficial para la entrega del beneficio 2026"
        file-url="files/REGLAMENTO DE ENTREGA DEL BJP GESTIÓN 2026.pdf"
        file-type="pdf"
      />

      <download-card
        title="Planilla de descargo"
        description="Formato actualizado de la planilla BJP 2026"
        file-url="files/PLANILLA BJP2026.xlsx"
        file-type="xlsx"
      />
    </div>
  </div>
</template>

<script>
import DownloadCard from "./DownloadCard.vue";

export default {
  name: "DocumentsSection",
  components: {
    DownloadCard,
  },
};
</script>

<style scoped>
.documents-content {
  width: 100%;
}

.documents-header {
  max-width: 680px;
  margin: 0 auto 2.4rem;
  text-align: center;
}

.section-kicker {
  display: inline-block;
  margin-bottom: 0.65rem;
  color: #ffffff;
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.documents-header h2 {
  margin-bottom: 0.75rem;
  color: var(--bjp-petrol-950);
  font-size: clamp(1.8rem, 4vw, 2.6rem);
  font-weight: 800;
  letter-spacing: -0.025em;
}

.documents-header p {
  margin: 0;
  color: #ffffff;
  font-size: 1rem;
  line-height: 1.65;
}

.documents-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.25rem;
}

@media (max-width: 991px) {
  .documents-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 767px) {
  .documents-header {
    margin-bottom: 1.75rem;
    padding: 0 0.5rem;
  }
  .documents-grid {
    grid-template-columns: 1fr;
  }
}
</style>
